import strFunc from "@/lib/lyg/string";
import DateFunc from '@/lib/lyg/date_func';
import ShopFunc from "@/pcomponents/common/content/shop/order/func/shop_func";

function OrderManageArea(props: any) {
  let myProps = {
    info: {},
    row_num: 0,
    order_det_arr: [],
    select_order_det_seq_arr: [],
    set_select_order_det_seq_arr: (inData: any) => { },
    delete_order_by_ajax: (inData: any) => { },
    delete_textbook_use_by_ajax: (inData: any) => { },
    go_use_of_order_det_by_ajax: (inData: any) => { },
    go_add_order_period_by_ajax: (inData: any) => { },
    send_payt_cancel_by_ajax: (inData: any) => { },
    send_payt_send_read_by_ajax: (inData: any) => { },
    open_request_order_popup: (inData: any) => { },
    open_find_textbook_each_order_popup: (inData: any) => { },
    ...props
  };
  let select_order_state_arr = ShopFunc.select_order_state_arr;
  let now_y_m_d = DateFunc.get_date_format(new Date(), "Y-m-d");
  let pre_month_y_m_d = DateFunc.get_date_format(DateFunc.get_change_date(new Date(), 'month', -1), "Y-m-d");
  let info = myProps.info;
  let textbook_use_arr: any = [];
  if (info.textbook_use_arr) {
    textbook_use_arr = info.textbook_use_arr;
  }

  let order_det_arr: any = [];
  for (let i = 0; i < myProps.order_det_arr.length; i++) {
    if (myProps.order_det_arr[i].a_buy_user_seq == info.a_seq) {
      order_det_arr.push(myProps.order_det_arr[i]);
    }
  }

  const select_check_toggle = (inData: any) => {
    let opt_obj = {
      order_det_seq: "",
      is_checked: false,
      ...inData
    };

    if (opt_obj.is_checked === true) {
      let change_select_order_det_seq_arr = [...myProps.select_order_det_seq_arr];
      change_select_order_det_seq_arr.push(opt_obj.order_det_seq);
      myProps.set_select_order_det_seq_arr(change_select_order_det_seq_arr);
    } else {
      let change_select_order_det_seq_arr = [];
      for (let i = 0; i < myProps.select_order_det_seq_arr.length; i++) {
        if (myProps.select_order_det_seq_arr[i] !== opt_obj.order_det_seq) {
          change_select_order_det_seq_arr.push(myProps.select_order_det_seq_arr[i]);
        }
      }
      myProps.set_select_order_det_seq_arr(change_select_order_det_seq_arr);
    }
  };

  const get_ready_order_det_tags = (inData: any) => {
    let opt_obj = {
      ready_order_det_arr: [],
      ...inData
    };
    let ready_order_det_tags: any = opt_obj.ready_order_det_arr.map((item: any, idx: number) => {
      let is_checked_order_det = false;
      let order_det_seq = item.a_ymd + "," + item.a_seq;
      if (strFunc.str_in_array(order_det_seq, myProps.select_order_det_seq_arr) != -1) {
        is_checked_order_det = true;
      }
      return (
        <div key={idx} >
          <label>
            <input type="checkbox" checked={is_checked_order_det}
              onChange={(e: any) => {
                select_check_toggle({ order_det_seq: order_det_seq, is_checked: e.target.checked });
              }} style={{ width: "16px", height: "16px" }} />
            <span className="ml-2">
              {item.a_product_type == "mtextbook" ? "교재" : "사용기간"}
            </span>
            <span className="ml-2">
              {strFunc.comma(item.a_price_sum)}원
            </span>
          </label>
          <button className="btn btn-red ml-1"
            onClick={() => {
              myProps.delete_order_by_ajax({ order_pri_val_arr: [item.a_order_seq] });
            }}>x</button>
        </div>
      );
    });
    return ready_order_det_tags;
  };

  const get_order_det_json_by_textbook_use = (inData: any) => {
    let opt_obj = {
      textbook_use: {},
      ...inData
    };
    let textbook_use = opt_obj.textbook_use;

    let book_product_seq_arr: any = [];
    if (textbook_use.textbook_info && textbook_use.textbook_info.product_info && textbook_use.textbook_info.product_info["a_seq"]) {
      book_product_seq_arr.push(textbook_use.textbook_info.product_info["a_seq"]);
    }
    if (textbook_use.textbook_info && textbook_use.textbook_info.product_info_use && textbook_use.textbook_info.product_info_use["a_seq"]) {
      book_product_seq_arr.push(textbook_use.textbook_info.product_info_use["a_seq"]);
    }

    let ready_order_det_arr: any = [];
    let ready_pay_order_det_arr: any = [];
    let unuse_order_det_arr: any = [];
    let pre_receive_det_arr: any = [];
    for (let i = 0; i < order_det_arr.length; i++) {
      if (order_det_arr[i].a_product_par_id == "shop_product"
        && strFunc.str_in_array(order_det_arr[i].a_product_par_seq, book_product_seq_arr) != -1) {

        if (order_det_arr[i].par_order_state == "ready") {
          ready_order_det_arr.push(order_det_arr[i]);
        } else if (order_det_arr[i].par_order_state == "ready_pay") {
          ready_pay_order_det_arr.push(order_det_arr[i]);
        } else {
          if (order_det_arr[i].order_info && order_det_arr[i].order_info["a_is_pay"] == "1"
            && order_det_arr[i].a_product_is_use != "1"
          ) {
            unuse_order_det_arr.push(order_det_arr[i]);
          }

          if (order_det_arr[i].order_info
            && order_det_arr[i].a_product_type == "mtextbook"
            && strFunc.str_in_array(order_det_arr[i].order_info["a_state"], ["request", "accept", "move", "complete)"]) != -1
          ) {
            pre_receive_det_arr.push(order_det_arr[i]);
          }
        }
      }
    }

    return {
      order_det_arr: order_det_arr,
      ready_order_det_arr: ready_order_det_arr,
      ready_pay_order_det_arr: ready_pay_order_det_arr,
      unuse_order_det_arr: unuse_order_det_arr,
      pre_receive_det_arr: pre_receive_det_arr,
    };
  };

  const get_show_textbook_use_arr = () => {
    let is_able_period = false;
    let able_textbook_use_arr: any = [];

    for (let i = 0; i < textbook_use_arr.length; i++) {
      let item = textbook_use_arr[i];
      if (!strFunc.is_empty(item.a_period_end_date) && item.a_period_end_date.substring(0, 4) != "0000") {
        if (item.a_period_end_date >= pre_month_y_m_d) {
          is_able_period = true;
        }
      }

      let order_det_json = get_order_det_json_by_textbook_use({ textbook_use: item });
      let ready_order_det_arr: any = order_det_json["ready_order_det_arr"];
      let ready_pay_order_det_arr: any = order_det_json["ready_pay_order_det_arr"];
      let unuse_order_det_arr: any = order_det_json["unuse_order_det_arr"];
      let pre_receive_det_arr: any = order_det_json["pre_receive_det_arr"];

      if (ready_order_det_arr.length > 0
        || ready_pay_order_det_arr.length > 0
        || unuse_order_det_arr.length > 0
        || pre_receive_det_arr.length > 0
      ) {
        is_able_period = true;
      }
      if (is_able_period) {
        able_textbook_use_arr.push(item);
      }
    }

    let show_textbook_use_arr: any = [];
    if (is_able_period == false) {
      show_textbook_use_arr = [textbook_use_arr[0]];
    } else {
      show_textbook_use_arr = able_textbook_use_arr;
    }
    return show_textbook_use_arr;
  };

  const get_daily_report_main_sub_text = (inData: any) => {
    let opt_obj = {
      textbook_use: {},
      ...inData
    };
    let textbook_use = opt_obj.textbook_use;
    let main_sub_text: any = "";
    if (info.last_daily_report_arr && info.last_daily_report_arr.length > 0) {
      for (let i = 0; i < info.last_daily_report_arr.length; i++) {
        let daily_report_item = info.last_daily_report_arr[i];
        if (daily_report_item.a_textbook_par_id == "mtextbook"
          && daily_report_item.a_textbook_seq == textbook_use.a_book_seq) {
          main_sub_text = (
            <span className="ml-1" style={{ color: "#888" }}>
              main
            </span>
          );
        } else if (daily_report_item.a_subtextbook_par_id == "mtextbook"
          && daily_report_item.a_subtextbook_seq == textbook_use.a_book_seq) {
          main_sub_text = (
            <span className="ml-1" style={{ color: "#888" }}>
              sub
            </span>
          );
        }
      }
    }
    return main_sub_text;
  };

  const get_use_tr_tags = () => {
    let show_textbook_use_arr = get_show_textbook_use_arr();
    let use_tr_tags: any = show_textbook_use_arr.map((item: any, idx: number) => {
      if (strFunc.is_empty(item)) {
        return "";
      }
      let period_str: any = "미사용";
      let remain_day_str: any = "-";
      let remain_day_style: any = {};
      let is_able_period = false;
      let is_max_period = false;
      let is_able_order_period = false;
      if (item && !strFunc.is_empty(item.a_period_end_date) && item.a_period_end_date.substring(0, 4) != "0000") {
        period_str = "~" + item.a_period_end_date;
        if (item.a_period_end_date >= now_y_m_d) {
          is_able_period = true;
          remain_day_str = DateFunc.get_diff_days_of_date(new Date(now_y_m_d), new Date(item.a_period_end_date));
          if (remain_day_str <= 7) {
            remain_day_style.color = "red";
          }
        } else {
          period_str = (
            <span style={{ color: "#909090" }}>{period_str}</span>
          );
        }
      }
      if (strFunc.uncomma_int(item["a_period_cnt"]) >= 3) {
        is_max_period = true;
      }
      let textbook_use_sort = "";
      if (item.textbook_info) {
        textbook_use_sort = item.textbook_info.a_use_sort;
        if (item.textbook_info.a_is_online == "1") {
          is_able_order_period = true;
        } else {
          period_str = "";
          if (item.a_period_end_date.substring(0, 4) != "0000" && item.a_period_end_date) {
            period_str = (
              <span style={{ color: "blue" }}>
                사용중
              </span>
            );
          }

          remain_day_str = "";
        }
      }

      let order_det_json = get_order_det_json_by_textbook_use({ textbook_use: item });
      let ready_order_det_arr: any = order_det_json["ready_order_det_arr"];
      let ready_pay_order_det_arr: any = order_det_json["ready_pay_order_det_arr"];
      let unuse_order_det_arr: any = order_det_json["unuse_order_det_arr"];
      let pre_receive_det_arr: any = order_det_json["pre_receive_det_arr"];
      let daily_report_main_sub_text = get_daily_report_main_sub_text({ textbook_use: item });

      return (
        <tr key={idx}>
          <td className="text-center">
            <div style={{position:"relative",textAlign:"center"}}>
              {item.textbook_title}
              <span style={{position:"absolute",right:0}}>
                {daily_report_main_sub_text}
              </span>
            </div>
          </td>
          <td className="text-center">
            {period_str}
          </td>
          <td className="text-center" style={remain_day_style}>
            {remain_day_str}
          </td>
          <td className="text-center">
            {ready_order_det_arr.length > 0 &&
              <div>
                {get_ready_order_det_tags({ ready_order_det_arr: ready_order_det_arr })}
              </div>
            }
            {ready_pay_order_det_arr.length > 0 &&
              <div>
                {ready_pay_order_det_arr.map((order_item: any, order_idx: number) => {

                  return (
                    <div key={order_idx}>
                      {(order_item.order_info && order_item.order_info["payt_supply"]
                        && order_item.order_info["payt_supply"]["a_state"] == "send") &&
                        <>
                          <button
                            className="btn btn-dark"
                            onClick={() => {
                              window.open(order_item.order_info["payt_supply"]["a_bill_url"]);
                            }} >결제링크</button>
                          <button className="btn btn-red ml-1"
                            onClick={() => {
                              myProps.send_payt_cancel_by_ajax({
                                selected_row: [order_item.order_info]
                              });
                            }}>결제취소</button>
                          <button className="btn-s btn-gray ml-1"
                            onClick={() => {
                              myProps.send_payt_send_read_by_ajax({
                                order_info_arr: [order_item.order_info]
                              });
                            }}
                          >상태확인</button>
                        </>
                      }
                    </div>
                  );
                })}
              </div>
            }
            {(ready_order_det_arr.length == 0 && is_max_period == false && is_able_order_period) &&
              <button className="btn-s btn-gray"
                onClick={() => {
                  myProps.go_add_order_period_by_ajax({
                    stu_seq: info["a_seq"],
                    order_book_seq_arr: [item.a_book_seq],
                    use_sort: textbook_use_sort
                  });
                }}
              >온라인연장</button>
            }
          </td>
          <td className="text-center">
            {(unuse_order_det_arr.length > 0) &&
              <>
                {unuse_order_det_arr.map((unuse_item: any, unuse_idx: number) => {
                  return (
                    <span key={unuse_idx}>
                      <button className="btn btn-dark"
                        onClick={() => {
                          myProps.go_use_of_order_det_by_ajax({
                            order_det_arr: [unuse_item]
                          });
                        }}>
                        {unuse_item.a_product_type.indexOf("period") != -1 ? "온라인연장" : "승인"}
                      </button>
                    </span>
                  );
                })}
              </>
            }
            <button className="btn btn-red ml-1"
              onClick={() => {
                if (ready_order_det_arr.length != 0) {
                  alert("주문 대기중인 주문건이 존재합니다. 주문 대기중인 주문건을 먼저 삭제해주세요.");
                  return false;
                }
                if (unuse_order_det_arr.length != 0) {
                  alert("미사용 주문건이 존재합니다. 미사용 주문건을 먼저 삭제해주세요.");
                  return false;
                }
                if (ready_pay_order_det_arr.length != 0) {
                  alert("주문 중인 교재는 삭제 할 수 없습니다.");
                  return false;
                }
                if (is_able_period) {
                  if (!confirm("사용기간이 남아있는 교재입니다. 정말 삭제하시겠습니까?")) {
                    return false;
                  }
                }
                myProps.delete_textbook_use_by_ajax({
                  textbook_use_arr: [item]
                });
              }} >삭제</button>
          </td>
          {/* <td>
            {pre_receive_det_arr.length > 0 &&
              <>
                {pre_receive_det_arr.map((pre_item: any, pre_idx: number) => {
                  let pre_order_state_text = "";
                  for (let i = 0; i < select_order_state_arr.length; i++) {
                    if (select_order_state_arr[i].value == pre_item.par_order_state) {
                      pre_order_state_text = select_order_state_arr[i].text;
                    }
                  }
                  let is_show_receive_btn = false;
                  if (pre_item.par_order_state == "complete") {
                    if (pre_item.order_info && pre_item.order_info["a_is_receive"] == "1") {
                      return "";
                    } else {
                      is_show_receive_btn = true;
                    }
                  }
                  return (
                    <div key={pre_idx} className="text-center">
                      {pre_order_state_text}
                    </div>
                  );
                })}
              </>
            }
          </td> */}
        </tr>
      );
    });

    if (strFunc.is_empty(use_tr_tags)) {
      use_tr_tags = (
        <tr>
          <td colSpan={5}>
            <div className="text-center" style={{ lineHeight: "20px" }}>
              내용이 없습니다.
            </div>
          </td>
        </tr>
      );
    }

    return use_tr_tags;
  };

  return (
    <div className="list-table-div">
      <table>
        <colgroup>
          <col style={{ width: "30%" }} />
          <col style={{ width: "20%" }} />
          <col style={{ width: "10%" }} />
          <col style={{ width: "10%" }} />
          <col style={{ width: "15%" }} />
          {/* <col style={{ width: "10%" }} /> */}
        </colgroup>
        <tbody>
          {get_use_tr_tags()}
        </tbody>
      </table>
    </div>
  );
};
export default OrderManageArea;